import { TagManagerEvent } from '../interfaces';

declare const dataLayer: Array<TagManagerEvent>;

declare module 'vue/types/vue' {
    // Global properties can be declared
    // on the `VueConstructor` interface
    interface VueConstructor {
        $gtm: {
            triggerEvent(event: TagManagerEvent)
        }
    }
}

export default class VueGoogleTagManager {
    static install(Vue, options?: any) {
        Vue.$gtm = {
            triggerEvent(value: TagManagerEvent) {
                if (typeof dataLayer !== 'undefined' && value?.event !== '') {
                    dataLayer.push(value);
                }
            }
        };
    }
}
